import { LanguageProvider } from "components/LanguageProvider.js";
import "styles/globals.css";

export default function App({ Component, pageProps }) {
  return (
    <div className="min-h-screen">
      <LanguageProvider>
        <Component {...pageProps} />
      </LanguageProvider>
    </div>
  );
}
